// Линейная история веток дебюта для тулбара ⏮ ◀ ▶ ⏭ (как курсор кадра в разборе):
// stack — сыгранные вперёд ходы, redo — откатанные (чтобы ▶/⏭ вернули срезанный ◀).
// Ручной выбор новой ветки (push) чистит redo. Чистая логика, без DOM.
export interface BranchFrame {
  fen: string;
  last: { from: string; to: string } | null;
}

export class BranchNav {
  private stack: BranchFrame[] = [];
  private redo: BranchFrame[] = [];

  constructor(
    private rootFen: string,
    private rootLast: { from: string; to: string } | null = null,
  ) {}

  /** Сбросить на корень выбранного дебюта (стек и redo пусты). */
  reset(fen: string, last: { from: string; to: string } | null): void {
    this.rootFen = fen;
    this.rootLast = last;
    this.stack = [];
    this.redo = [];
  }

  /** Сыграть новый ход — обрезает redo (началась новая ветка). */
  push(frame: BranchFrame): void {
    this.stack.push(frame);
    this.redo = [];
  }

  /** ◀ — на ход назад по ветке (срезанный ход попадает в redo). */
  back(): void {
    const f = this.stack.pop();
    if (f) this.redo.push(f);
  }

  /** ▶ — redo: вернуть последний срезанный ◀ ход. */
  forward(): void {
    const f = this.redo.pop();
    if (f) this.stack.push(f);
  }

  /** ⏮ — в начало линии (весь стек уходит в redo, ⏭ его вернёт). */
  toStart(): void {
    while (this.stack.length) this.redo.push(this.stack.pop()!);
  }

  /** ⏭ — redo всего стека до конца ветки. */
  toEnd(): void {
    while (this.redo.length) this.stack.push(this.redo.pop()!);
  }

  get fen(): string {
    return this.stack.length ? this.stack[this.stack.length - 1]!.fen : this.rootFen;
  }

  get move(): { from: string; to: string } | null {
    return this.stack.length ? this.stack[this.stack.length - 1]!.last : this.rootLast;
  }

  get atStart(): boolean {
    return this.stack.length === 0;
  }

  get atEnd(): boolean {
    return this.redo.length === 0;
  }
}

/** UCI самого популярного хода теории (топ-1 explorer) в текущей позиции или null. */
export function topTheoryUci(rows: { uci: string }[]): string | null {
  return rows[0]?.uci ?? null;
}
